import classNames from 'classnames';
import React from 'react';
import { Except } from '../type-utils';
import './Checkbox.scss';
import { ReactComponent as CheckIcon } from './icons/checkbox-check.svg';

interface Props extends Except<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: React.ReactNode
  icon?: JSX.Element
  title?: string
}

export default function Checkbox({ className, label, icon, title, ...props }: Props) {
  return <label className={classNames('Checkbox', className)} title={title} >
    <input type='checkbox' {...props} />
    <div className='checkbox'>
      <CheckIcon className='check' />
    </div>
    {label && label}
    {icon && icon}
  </label>
}
